import React, {ReactNode} from 'react'
import {TableRowName} from '../../../styledComponents/adminPage/Table'
import PPRadioGroup from '../../shared/forms/PPRadioGroup'
import {UNIT_OF_FACILITY_RESERVATION_RECEPTION_START_TIME} from '../../../CodeMaster'
import PPNumericField from '../../shared/forms/PPNumericField'
import {HKConstants} from '../../../HKConstants'
import {LeftRowFlexContainer} from '../../../styledComponents/FlexComponents'
import { Box, TableRow, TableCell, InputAdornment } from '@mui/material';
import {ReservationSettings} from './ReservationSettingsComponent'
import {numberOrNull, stringOrEmpty} from '../../../stringHelper/stringHelpers'
import {Nullable} from '../../../app/TypeHelpers'
import equal from 'fast-deep-equal'
import EventEmitterExAdmin from '../../shared/pageBaseComponents/EventEmitterExAdmin'
import styled from 'styled-components'

interface ReservationReceptionStartTimeSettings {
    unitOfReserveReceptionStartTime: UNIT_OF_FACILITY_RESERVATION_RECEPTION_START_TIME
    reserveReceptionStartMonth: Nullable<number>
    reserveReceptionStartDate: Nullable<number>
}

interface Props extends ReservationReceptionStartTimeSettings {
    eventEmitter: EventEmitterExAdmin
    handleReservationSettingsChange: (reservationSettings: Partial<ReservationSettings>) => void
}

class ReservationReceptionStartTimeComponent extends React.Component<Props> {

    static displayName: string = 'ReservationReceptionStartTimeComponent'

    constructor(props: Readonly<Props>) {
        super(props)

        this.handleUnitOfReserveReceptionStartTimeChange = this.handleUnitOfReserveReceptionStartTimeChange.bind(this)
    }

    shouldComponentUpdate(nextProps: Readonly<Props>): boolean {
        return !(this.props === nextProps || equal(this.props, nextProps))
    }

    handleUnitOfReserveReceptionStartTimeChange(event: React.ChangeEvent<HTMLInputElement>): void {
        const {handleReservationSettingsChange, eventEmitter, ...rest} = this.props
        const unitOfReserveReceptionStartTime: UNIT_OF_FACILITY_RESERVATION_RECEPTION_START_TIME =
            UNIT_OF_FACILITY_RESERVATION_RECEPTION_START_TIME.codeToEnumConstants(`${event.target.value}`)

        handleReservationSettingsChange({
            ...rest,
            unitOfReserveReceptionStartTime: unitOfReserveReceptionStartTime,
        })
    }

    handleNumericValueChange = (target: string) => (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
        const {handleReservationSettingsChange, eventEmitter, ...rest} = this.props

        handleReservationSettingsChange({
            ...rest,
            [target]: numberOrNull(`${event.target.value}`),
        })
    }

    renderSpecifyMonth(): ReactNode {
        if (this.props.unitOfReserveReceptionStartTime !==
            UNIT_OF_FACILITY_RESERVATION_RECEPTION_START_TIME.SPECIFIED_MONTH) {
            return null
        }

        return (<>
            <label>
                <ReserveReceptionStartInput
                    InputProps={{
                        inputProps: {
                            min: 1,
                            max: HKConstants.VMN.FAC.MAX_RESERVATION_ACCEPTANCE_START_MONTH,
                        },
                        endAdornment: <InputAdornment position="end">ヶ月前</InputAdornment>,
                    }}
                    value={stringOrEmpty(this.props.reserveReceptionStartMonth)}
                    eventEmitter={this.props.eventEmitter}
                    eventKeys={['reservationSetting.reserveReceptionStartMonth']}
                    onChange={this.handleNumericValueChange('reserveReceptionStartMonth')}
                />
            </label>
        </>)
    }

    renderSpecifyDay(): ReactNode {
        if (this.props.unitOfReserveReceptionStartTime !==
            UNIT_OF_FACILITY_RESERVATION_RECEPTION_START_TIME.SPECIFIED_DAY) {
            return null
        }

        return (<>
            <label>
                <ReserveReceptionStartInput
                    InputProps={{
                        inputProps: {
                            min: 1,
                            max: HKConstants.VMN.FAC.MAX_RESERVATION_ACCEPTANCE_START_DAY,
                        },
                        endAdornment: <InputAdornment position="end">日前</InputAdornment>,
                    }}
                    value={stringOrEmpty(this.props.reserveReceptionStartDate)}
                    eventEmitter={this.props.eventEmitter}
                    eventKeys={['reservationSetting.reserveReceptionStartDate']}
                    onChange={this.handleNumericValueChange('reserveReceptionStartDate')}
                />
            </label>
        </>)
    }

    render(): ReactNode {
        return (<>
            <TableRow>
                <TableRowName>予約受付開始日</TableRowName>
                <TableCell>
                    <LeftRowFlexContainer>
                        <PPRadioGroup
                            row
                            data={UNIT_OF_FACILITY_RESERVATION_RECEPTION_START_TIME.values()}
                            value={this.props.unitOfReserveReceptionStartTime.value}
                            onChange={this.handleUnitOfReserveReceptionStartTimeChange}
                        />
                        <Box marginRight={'30px'}/>
                        {this.renderSpecifyMonth()}
                        {this.renderSpecifyDay()}
                    </LeftRowFlexContainer>
                </TableCell>
            </TableRow>
        </>)
    }
}

const ReserveReceptionStartInput = styled(PPNumericField)`
  width: 110px;
`

export default ReservationReceptionStartTimeComponent
